<template lang="pug">
    v-form.c-form(autocomplete="off")

        // Business Name field
        v-text-field(
            :error-messages="errors.collect('businessName')"
            :data-vv-as="$t('fields.businessName')"
            :label="$t('fields.businessName')"
            name="businessName"
            v-model="model.name"
            v-validate="'required|min:2|max:100'"
            outline
        )

        // Contact Email field
        v-text-field(
            :error-messages="errors.collect('contactEmail')"
            :data-vv-as="$t('fields.contactEmail')"
            :label="$t('fields.contactEmail')"
            name="contactEmail"
            type="email"
            v-model="model.owner.email"
            v-validate="'required|email'"
            outline
        )

        // Сontact Name field
        v-text-field(
            :error-messages="errors.collect('contactName')"
            :data-vv-as="$t('fields.contactName')"
            :label="$t('fields.contactName')"
            name="contactName"
            v-model="model.owner.fullName"
            v-validate="'required|min:2|max:72'"
            outline
        )

        // Contact Phone field
        v-text-field(
            :error-messages="errors.collect('phone')"
            :data-vv-as="$t('fields.phone')"
            :label="$t('fields.phone')"
            name="phone"
            v-model="model.owner.phone"
            v-validate="'required|min:6'"
            mask="###-###-######-####"
            outline
        )

        // Max Capacity field
        v-text-field(
            :error-messages="errors.collect('maxUsers')"
            :data-vv-as="$t('fields.maxUsers')"
            :label="$t('fields.maxUsers')"
            name="maxUsers"
            v-model.lazy="model.maxUsers"
            v-validate="'required|numeric|min_value:1|max_value:15000'"
            outline
        )

        // Participate in Challenge
        v-checkbox(
            v-model="model.isChallenge"
            :label="$t('fields.challenge')"
        )

        // Max Capacity field
        v-text-field(
            :error-messages="errors.collect('domain')"
            :data-vv-as="$t('fields.domain')"
            :label="$t('fields.domain')"
            name="domain"
            v-model.lazy="model.domain"
            v-validate="'required|min:2|max:512'"
            outline
        )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        computed: {
            ...mapFields('businesses', {
                model: 'business'
            })
        },
        methods: {
            ...mapActions('businesses', ['update']),

            /**
             * Create business on submit
             * @returns {boolean}
             */
            async submitForm() {
                // Validate all fields
                const validation = await this.$validator.validateAll();

                // Check validation pass
                if (!validation) return;

                // Call store action
                this.update();
            }
        }
    };
</script>
